import React from 'react';
import { CheckIcon } from 'lucide-react';
import { trackFbEvent } from '../utils/fbpixel';
export function HeroSection() {
  return <section id="hero" className="relative w-full flex flex-col items-center justify-between px-4 pb-3 bg-[#F8F5FC] overflow-hidden" style={{
    height: 'calc(100dvh - 32px)',
    paddingTop: 'max(env(safe-area-inset-top, 0px), 0.5rem)'
  }} data-id="element-117">
      <div className="relative z-10 flex flex-col items-center text-center gap-1.5 max-w-lg w-full flex-1 justify-between min-h-0 py-2" data-id="element-118">
        {/* Element 1: Pill */}
        <div className="hero-fade-1 inline-flex items-center px-3 py-0.5 rounded-full text-[11px] font-bold text-brand-violet border border-brand-violet bg-brand-violet/5" data-id="element-119">
          Método pH-ZERO
        </div>

        {/* Element 2 & 3: Title + Mockup + Subtitle */}
        <div className="flex flex-col items-center gap-1 min-h-0 flex-shrink" data-id="element-120">
          <h1 className="hero-fade-2 text-[22px] sm:text-[28px] font-bold leading-[1.1] text-brand-text" data-id="element-121">
            Cándida recurrente: el ciclo que nadie te explicó (y cómo cortarlo)
          </h1>
          <img src="https://cdn.magicpatterns.com/uploads/qeMGyiRr8YXTyoDvtX1uxE/IMG_0034.png" alt="Método pH-ZERO" className="hero-fade-2 w-full max-w-[180px] sm:max-w-[240px] h-auto object-contain" data-id="element-122" />
          <p className="hero-fade-3 text-[13px] text-brand-muted leading-snug px-2" data-id="element-123">
            Guía práctica para romper el ciclo con alimentación y herramientas
            para que no vuelva.
          </p>
        </div>

        {/* Element 4: 3 Feature Pills */}
        <div className="hero-fade-4 w-full flex flex-col gap-1" data-id="element-124">
          <div className="flex items-start gap-2 bg-brand-gray rounded-lg px-2.5 py-1.5 text-left shadow-sm" data-id="element-125">
            <div className="bg-white rounded-full p-0.5 shadow-sm flex-shrink-0 mt-0.5" data-id="element-126">
              <CheckIcon size={11} className="text-brand-violet" strokeWidth={3} data-id="element-127" />
            </div>
            <p className="text-[11px] text-brand-text leading-snug" data-id="element-128">
              <strong data-id="element-129">Guía paso a paso:</strong> Cortá la recurrencia de raíz.
            </p>
          </div>
          <div className="flex items-start gap-2 bg-brand-gray rounded-lg px-2.5 py-1.5 text-left shadow-sm" data-id="element-130">
            <div className="bg-white rounded-full p-0.5 shadow-sm flex-shrink-0 mt-0.5" data-id="element-131">
              <CheckIcon size={11} className="text-brand-violet" strokeWidth={3} data-id="element-132" />
            </div>
            <p className="text-[11px] text-brand-text leading-snug" data-id="element-133">
              <strong data-id="element-134">Alimentación + Listas:</strong> Bajá inflamación y ardor
              sin adivinar qué comer.
            </p>
          </div>
          <div className="flex items-start gap-2 bg-brand-gray rounded-lg px-2.5 py-1.5 text-left shadow-sm" data-id="element-135">
            <div className="bg-white rounded-full p-0.5 shadow-sm flex-shrink-0 mt-0.5" data-id="element-136">
              <CheckIcon size={11} className="text-brand-violet" strokeWidth={3} data-id="element-137" />
            </div>
            <p className="text-[11px] text-brand-text leading-snug" data-id="element-138">
              <strong data-id="element-139">Hábitos y Prevención:</strong> Higiene íntima,
              suplementación y señales de alerta.
            </p>
          </div>
        </div>

        <div className="w-full flex flex-col gap-2" data-id="element-140">
          {/* Element 5: CTA Button */}
          <a href="#compra" onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: 'Hero CTA',
          value: 19990,
          currency: 'ARS'
        })} className="hero-fade-5 w-full bg-brand-magenta hover:brightness-110 text-white font-bold text-[14px] rounded-xl py-3 px-6 text-center transition-all shadow-[0_4px_24px_rgba(212,0,110,0.25)]" data-id="element-141">
            🔓 QUIERO MATAR AL HONGO
          </a>

          {/* Element 6: Trust Bar */}
          <div className="hero-fade-6 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-0.5 text-[10px] text-brand-muted font-medium" data-id="element-142">
            <span data-id="element-143">🔒 Pago seguro</span>
            <span data-id="element-144">·</span>
            <span data-id="element-145">📲 Descarga instantánea</span>
            <span data-id="element-146">·</span>
            <span data-id="element-147">🇦🇷 Hecho para Argentina</span>
          </div>
        </div>
      </div>
    </section>;
}